'use client';

import { TypesenseEventDocument } from '@/types';
import { format } from 'date-fns';
import { parseAsIsoDateTime, useQueryState } from 'nuqs';

import { formatTimeRange } from '@/lib/server';

import { Text } from '../text';

export function EventTime({ instances }: { instances: TypesenseEventDocument[] }) {
  const [searchDate] = useQueryState('date', parseAsIsoDateTime.withDefault(new Date(instances?.[0]?.dates * 1000)));

  const searchDateInstance = instances.find(
    (instance) => new Date(instance.dates * 1000).toISOString() === searchDate?.toISOString(),
  );

  return (
    searchDateInstance && (
      <Text element="p" className="flex items-center gap-2">
        {`${format(searchDateInstance.dates * 1000, 'EE do MMM')} at ${formatTimeRange(searchDateInstance.dates, searchDateInstance.dates_end) || '6:00 PM'}`}
      </Text>
    )
  );
}
